import { i18n } from "./../../../plugins/vue-i18n";

const validateNaturalPersonFirstName = {
  validate: validate,
  message: i18n.t("VALIDATION_ERRORS.validateNaturalPersonFirstName")
};

function validate(input) {
  return input.length >= 3;
}

export default validateNaturalPersonFirstName;
